import { MainContent } from '@/components/content'
import { ArrowBack } from '@/components/icons'
import { MainLayout } from '@/components/layouts'
import { SettingSidebar } from '@/components/sidebar'
import { ROUTE_DASHBOARD, ROUTE_PASSWORD_SECURITY, ROUTE_TWO_FACTOR } from '@/constants/Routes'
import { useAppDispatch } from '@/hooks/useRedux'
import { setShowDropDown } from '@/pages/home/appSlice'
import { useTranslation } from 'react-i18next'
import { Link, NavLink, Outlet } from 'react-router-dom'

export type { ChangePasswordForm } from './change-password'

/**
 * The "Password and Security" settings entry: one page with two sub-sections, each its own URL so
 * it can be linked to directly and the sidebar entry stays lit for both —
 * - change password (the index route, `ChangePassword`), and
 * - two-factor authentication (`two-factor`, the `TwoFactor` page in its settings variant).
 * The sub-sections render bare inside the `<Outlet />`; this page owns the shell and the heading.
 */
export const PasswordSecurity = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const sections = [
    { to: ROUTE_PASSWORD_SECURITY, end: true, label: t('user.changePass') },
    { to: ROUTE_TWO_FACTOR, end: false, label: t('common.twoFactor', 'Two-factor authentication') },
  ]

  return (
    <MainLayout>
      <SettingSidebar />
      <MainContent>
        <div className="flex flex-col items-center w-full">
          <div className="flex flex-col w-full lg:w-[520px] gap-y-6 mb-20 lg:mb-8">
            <div className="flex items-center gap-x-3">
              <Link to={ROUTE_DASHBOARD} className="flex sm:hidden" onClick={() => dispatch(setShowDropDown(''))}>
                <ArrowBack className="text-white" />
              </Link>
              <h1 className="text-2xl md:text-[32px] md:leading-10 font-bold text-white">
                {t('common.passwordSecurity')}
              </h1>
            </div>

            <nav aria-label={t('common.passwordSecurity')} className="flex gap-x-2 border-b border-white/10">
              {sections.map((section) => (
                <NavLink
                  key={section.to}
                  to={section.to}
                  end={section.end}
                  className={({ isActive }) =>
                    `-mb-px border-b-2 px-3 py-2 text-sm font-semibold transition-colors ${
                      isActive
                        ? 'border-azul text-white'
                        : 'border-transparent text-white/60 hover:text-white'
                    }`
                  }
                >
                  {section.label}
                </NavLink>
              ))}
            </nav>

            <Outlet />
          </div>
        </div>
      </MainContent>
    </MainLayout>
  )
}
